import { render, staticRenderFns } from "./NewMultiSelectDropdown.vue?vue&type=template&id=87c5c7de"
import script from "./NewMultiSelectDropdown.vue?vue&type=script&lang=js"
export * from "./NewMultiSelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./NewMultiSelectDropdown.vue?vue&type=style&index=0&id=87c5c7de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports